import styled from "styled-components";
import { Wrapper } from 'AppReact';

export const template = styled.span`background: #04333BE5;`;

export default Wrapper(template);
